
import React from 'react';

const EnrollmentSection: React.FC = () => {
  return (
    <section id="enrollment" className="py-20 bg-teal-50/50">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Completa tu matrícula
          </h2>
          <p className="text-lg text-gray-600">
            Recibirás acceso inmediato a tu correo electrónico
          </p>
        </div>
        
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
          <iframe 
            aria-label='Matrícula Curso Cefa' 
            style={{height: '500px', width: '99%', border: 'none'}} 
            src='https://forms.zohopublic.com/institutocefa1/form/MatrculaAuxiliarVeterinaria/formperma/ir-LeSAMZOy7nAAilckUiPu4FyJhNY2WAX4QTyndF4c?curso=Auxiliar%20de%20T%C3%A9cnico%20Veterinario'
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default EnrollmentSection;
